import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from './material.module';
import { SharedModule } from '../shared/shared.module';

import { InscripcionesAuditoriaListadoComponent } from '@components/pages/auditoria-inscripciones/inscripciones-auditoria-listado/inscripciones-auditoria-listado.component';
import { InscripcionesAuditoriaDetalleComponent } from '@components/pages/auditoria-inscripciones/inscripciones-auditoria-detalle/inscripciones-auditoria-detalle.component';

@NgModule({
    declarations: [
        InscripcionesAuditoriaListadoComponent,
        InscripcionesAuditoriaDetalleComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MaterialModule,
        SharedModule,
    ],
})
export class AuditoriaInscripcionesModule {}
